(function () {
  'use strict';
  var contact = document.querySelector('[data-nytarp-contact]');
  if (!contact) return;

  // Current Shopify Forms country selector: let the app handle Escape. Restore
  // focus only if its known listbox closes and native handling loses focus.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || typeof event.composedPath !== 'function') return;
    var path = event.composedPath();
    var listbox = path.filter(function (node) {
      return node && node.nodeType === 1 && node.id === 'country-selector-dropdown' && node.getAttribute('role') === 'listbox';
    })[0];
    if (!listbox || typeof listbox.getRootNode !== 'function') return;
    var root = listbox.getRootNode();
    var host = root.host || listbox.closest('shopify-forms-embed');
    if (!host || host.tagName !== 'SHOPIFY-FORMS-EMBED' || !contact.contains(host) || !host.closest('[data-nytarp-contact-app]')) return;
    if (root.host && (root.mode !== 'open' || host.shadowRoot !== root)) return;
    var trigger = (root.host ? root : host).querySelector('button[aria-expanded="true"][aria-controls="country-selector-dropdown"]');
    if (!trigger) return;
    window.setTimeout(function () {
      if (!trigger.isConnected || trigger.getAttribute('aria-expanded') !== 'false' || listbox.isConnected) return;
      var active = document.activeElement;
      while (active && active.shadowRoot && active.shadowRoot.activeElement) active = active.shadowRoot.activeElement;
      if (!active || active === document.body || active === host) trigger.focus();
    }, 0);
  }, true);

  var form = contact.querySelector('#NytContactForm');
  if (!form) return;
  var summary = form.querySelector('[data-contact-error-summary]');
  if (summary) {
    var fallback = form.closest('details');
    if (fallback) fallback.open = true;
    summary.focus();
  }
  var invalidQueued = false;
  form.addEventListener('invalid', function (event) {
    event.target.setAttribute('aria-invalid', 'true');
    if (invalidQueued) return;
    invalidQueued = true;
    window.setTimeout(function () {
      invalidQueued = false;
      var first = form.querySelector(':invalid');
      if (first) first.focus();
    }, 0);
  }, true);
  form.addEventListener('input', function (event) {
    var field = event.target;
    if (field.validity && field.validity.valid && !field.hasAttribute('aria-describedby')) field.removeAttribute('aria-invalid');
  });
}());
